<template>
  <div>
    <validation-observer ref="channelForm">
      <b-form @submit.prevent=""
        @reset.prevent="resetForm">
        <div class="row">
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              name="Tên kênh"
              vid="name"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Tên kênh <span class="text-danger">*</span></label>
                </template>
                <b-form-input type="text"
                  id="name"
                  v-model="frmData.name"
                  :state="getValidationState(validationContext)"
                  placeholder="Nhập..." />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              name="code"
              vid="code"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Mã kênh <span class="text-danger">*</span></label>
                </template>
                <b-form-input type="text"
                  v-model="frmData.code"
                  :state="getValidationState(validationContext)"
                  placeholder="Nhập..." />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              vid="channel_group_id"
              name="Nhóm kênh"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Nhóm kênh <span class="text-danger">*</span></label>
                </template>
                <v-select v-model="frmData.channel_group_id"
                  :options="dataChannelGroup"
                  label="app_name"
                  :reduce="(val) => val.id"
                  placeholder="--Chọn--"
                  :state="getValidationState(validationContext)" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              name="Stream name"
              trim
              vid="stream_name"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Stream name <span class="text-danger">*</span></label>
                </template>
                <b-form-input type="text"
                  v-model="frmData.stream_name"
                  :state="getValidationState(validationContext)"
                  placeholder="Nhập..." />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              vid="channel_category_id"
              name="Danh mục kênh"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Danh mục kênh <span class="text-danger">*</span></label>
                </template>
                <v-select v-model="frmData.channel_category_id"
                  :options="channelCategory"
                  label="title"
                  :reduce="(val) => val.id"
                  placeholder="--Chọn--"
                  :state="getValidationState(validationContext)" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-12 col-md-6">
            <validation-provider #default="validationContext"
              vid="type"
              name="Thể loại"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Thể loại <span class="text-danger">*</span></label>
                </template>
                <v-select v-model="frmData.type"
                  :options="dataType"
                  label="name"
                  :reduce="(val) => val.code"
                  placeholder="--Chọn--"
                  :state="getValidationState(validationContext)" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <validation-provider #default="validationContext"
          name="Đường link"
          vid="link"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Đường link <span class="text-danger">*</span></label>
            </template>
            <b-form-input type="text"
              id="name"
              v-model="frmData.link"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-checkbox v-model="frmData.status"
          value="1"
          class="custom-control-primary"> Kích hoạt </b-form-checkbox>
        <div class="d-flex mt-1">
          <b-button variant="danger"
            type="submit"
            @click.prevent="validationForm"> {{ $t('Save') }} </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { required, email, alphaNum, min, max, } from '@validations'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast, useRouter } from '@core/utils/utils';
import vSelect from 'vue-select'
export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
    vSelect
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    },
    dataChannelGroup: Array,
    dataType: Array,
    channelCategory: Array
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const blankData = {
      name: '',
      code: '',
      stream_name: '',
      link: '',
      type: '',
      channel_category_id: '',
      channel_group_id: '',
      status: 1
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))

    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)


    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
    }
  },
  methods: {
    onSubmit() {
      if (this.frmData.id) {
        store.dispatch('channel/update', { data: this.frmData, id: this.frmData.id, card_type: 'channel' })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$emit('updateList');

            } else {
              if (result.errors) {
                this.$refs.channelForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      } else {
        store.dispatch('channel/create', { card_type: 'channel', params: this.frmData })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else {
              if (result.errors) {
                this.$refs.channelForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.channelForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
}
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>